import React from 'react'
import {
    getSessionCompany,
    getSessionManagingCompany,
    getSessionManagingName,
    getSessionName,
    getSessionUser
} from '../../utils/auth'
import './UserEmail.scss'

class UserEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            company: '',
            managingCompany: '',
            managingName: '',
        };
    }

    componentDidMount() {
        this.setState({
            company: getSessionCompany() || '',
            name: getSessionName() || '',
            user: getSessionUser() || '',
            managingCompany: getSessionManagingCompany() || '',
            managingName: getSessionManagingName() || '',
        });
    }

    render() {
        const {company, name, user, managingCompany, managingName} = this.state;

        return <div className="user-info">
            {managingCompany && (
                <span className="partner-login-banner">
                    Session managed by: <strong>{managingCompany}</strong>
                    {managingName && <span> ({managingName})</span>}
                </span>
            )}
            <span className="company-name">{company || name} ({user})</span>
        </div>
    }
}

export default UserEmail;
